import PageLayout from '../../layout/PageLayout'
import AboutSection from './components/AboutSection'
import CompanyProjectsSection from '../projects/components/CompanyProjectsSection'

export default function AboutPage() {
  return (
    <PageLayout>
      <AboutSection />
      <CompanyProjectsSection />
    </PageLayout>
  )
}
